/**
 * Legalbus COP REST API 1.0
 * REST API for the Legalbus COP digital signature platform
 *
 * The version of the OpenAPI document: 2.30.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IQPAdditionalData } from './iQPAdditionalData';
import { UploadedIdentityDocument } from './uploadedIdentityDocument';
import { Person } from './person';


export interface DocumentCaptureStatus { 
    selectedCountry?: string;
    selectedIdentityDocument?: DocumentCaptureStatus.SelectedIdentityDocumentEnum;
    uploadedIdentityDocuments?: Array<UploadedIdentityDocument>;
    updatedPerson?: boolean;
    person?: Person;
    docCaptureStatus?: DocumentCaptureStatus.DocCaptureStatusEnum;
    reasons?: Set<string>;
    previousReasons?: Set<string>;
    additionalData?: Array<IQPAdditionalData>;
}
export namespace DocumentCaptureStatus {
    export type SelectedIdentityDocumentEnum = 'ID_CARD' | 'ELECTRONIC_ID_CARD' | 'DRIVING_LICENSE' | 'FISCAL_CODE' | 'PASSPORT' | 'SELFIE';
    export const SelectedIdentityDocumentEnum = {
        IdCard: 'ID_CARD' as SelectedIdentityDocumentEnum,
        ElectronicIdCard: 'ELECTRONIC_ID_CARD' as SelectedIdentityDocumentEnum,
        DrivingLicense: 'DRIVING_LICENSE' as SelectedIdentityDocumentEnum,
        FiscalCode: 'FISCAL_CODE' as SelectedIdentityDocumentEnum,
        Passport: 'PASSPORT' as SelectedIdentityDocumentEnum,
        Selfie: 'SELFIE' as SelectedIdentityDocumentEnum
    };
    export type DocCaptureStatusEnum = 'IN_PROGRESS' | 'OCR_COMPLETED' | 'COMPLETED' | 'COMPLETED_WITH_WARNINGS' | 'INVALID' | 'FAILED';
    export const DocCaptureStatusEnum = {
        InProgress: 'IN_PROGRESS' as DocCaptureStatusEnum,
        OcrCompleted: 'OCR_COMPLETED' as DocCaptureStatusEnum,
        Completed: 'COMPLETED' as DocCaptureStatusEnum,
        CompletedWithWarnings: 'COMPLETED_WITH_WARNINGS' as DocCaptureStatusEnum,
        Invalid: 'INVALID' as DocCaptureStatusEnum,
        Failed: 'FAILED' as DocCaptureStatusEnum
    };
}


